import { Switch, Route } from 'react-router';
import React from 'react';
import { List } from 'scenes';
import PropTypes from 'prop-types';
import { DefaultLayout } from 'components/layout';

export const wrapperList = ({ match }) => (
  <DefaultLayout>
    <Switch>
      <Route path={`${match.url}`} component={List} />
    </Switch>
  </DefaultLayout>
);

wrapperList.propTypes = {
  match: PropTypes.object,
};
